module.exports = __webpack_public_path__ + "img/step-image3.fc18925a.jpg";